
import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { isNullOrUndefined } from 'util';
import { BaseLevelColumnConfig, DisasterTableConfiguration } from '../disaster-monitoring-map/disaster-monitoring-map-constants';
import { MonitorDashboardService } from '../monitor-dashboard.service';
import { AgricultureMapConstants } from 'src/app/main/constants/dims-map-constants';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilsService } from 'src/app/utils/utils.service';

@Component({
  selector: 'app-disaster-popup-table',
  templateUrl: './disaster-popup-table.component.html',
  styleUrls: ['./disaster-popup-table.component.scss']
})
export class DisasterPopupTableComponent implements OnInit {

  queryParams: any;
  tableConfig: {
    options: any,
    data: any[],
    id: any,
    visible: boolean,
    spinner: boolean
  } = {
      options: this.monitorSrv.deepClone(DisasterTableConfiguration),
      data: [],
      id: 'disaster data table',
      visible: false,
      spinner: true
    };
    disasterData:any;
    selectedDisasterType: any = 'Flood';
  constructor(
    public activeModal: NgbActiveModal,
    private monitorSrv: MonitorDashboardService,
    private router: Router,
    private utils: UtilsService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.selectedDisasterType = this.queryParams.disasterType || 'Flood';

    this.tableConfig.options = this.monitorSrv.deepClone(DisasterTableConfiguration);
    this.updateDownloadFileNames();

    this.getTableData();
  }

  closeModal() {
    this.activeModal.close();
  }
  getTableData() {
    let postData = {
      'disasterType': isNullOrUndefined(this.queryParams.disasterType) ? 'Flood' : this.queryParams.disasterType,
      "timeFormat": (isNullOrUndefined(this.queryParams.year) || this.queryParams.year == 'ALL') ? "Yearly" : "Monthly",
      "timePeriod": (isNullOrUndefined(this.queryParams.year) || this.queryParams.year == 'ALL') ? 'ALL' : this.queryParams.year
    }
    // this.monitorSrv.getDisasterTableData(postData).subscribe(res => {
      if (!isNullOrUndefined(this.disasterData)) {
        this.tableConfig.spinner = false
        this.tableConfig.visible = true
        this.tableConfig.options.columns = this.monitorSrv.deepClone(BaseLevelColumnConfig);
        this.tableConfig.data = this.getFormattedTableData(this.disasterData)
      } else {
        this.tableConfig.spinner = false
        this.tableConfig.visible = true
        this.tableConfig.data = []
      }
    // }, err => {
    //   this.tableConfig.spinner = false
    //   this.tableConfig.visible = true
    //   this.tableConfig.data = []
    // })
  }

  getFormattedTableData(data) {
    for (let i in data) {
      let item = data[i]
      item['name'] = item['ln'] ? item['ln'][0] : '-'
      item['affected'] = !isNullOrUndefined(item['affected']) ? (item['affected']).toString() : '-';
      item['homeless'] = !isNullOrUndefined(item['homeless']) ? (item['homeless']).toString() : '-';
      item['totalDam'] = !isNullOrUndefined(item['totalDam']) ? ((item['totalDam'] * 88.66).toFixed(2)) : '-';
      item['injured'] = !isNullOrUndefined(item['injured']) ? (item['injured']).toString() : '-';
      item['totalDeath'] = !isNullOrUndefined(item['totalDeath']) ? (item['totalDeath']).toString() : '-';
    }
    return data
  }

  tableRowClick(data: any) {
    let allLocations: any = this.queryParams['location'].split('&');
    if (data != undefined && data.values != undefined && data.values.length > 1) {
      const levels = AgricultureMapConstants.ADMIN_BOUNDARIES_HIE
      let firstLevel: any = levels[levels.indexOf(this.queryParams.locType) + 1];
      const locType = firstLevel
      const locName = data.values[0];
      const pUUID = data.values[1];
      let location = this.queryParams.location + '&' + this.utils.titleCase(data.values[0]) + '##' + data.values[1];
      let obj = {
        locType,
        locName,
        pUUID,
        location
      }
      this.router.navigate(['.'], {
        relativeTo: this.route,
        queryParams: obj,
        queryParamsHandling: 'merge'
      });
    } else {
      console.log('Incorrect parameters of the clicked column. Cannot drill down into the location.');
    }
  }

  updateDownloadFileNames() {
  let fileName = this.selectedDisasterType;

  if (this.queryParams && this.queryParams.source) {
    fileName = fileName + '_' + this.queryParams.source;
  }

  let selectedYear = 'ALL';

  if (this.queryParams && this.queryParams.year) {
    selectedYear = this.queryParams.year;
  }

  fileName = fileName + '_' + selectedYear;

  if (this.tableConfig.options && this.tableConfig.options.downloadOptions) {
    this.tableConfig.options.downloadOptions.forEach(option => {
      option.downloadFileName = fileName;
    });
    }
  }
}


